"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const httpRequest_1 = require("./httpRequest");
/**Convierte un HttpMiddleware a uno que devuelve StatusErrorResponse */
async function statusErrorMiddleware(req, next) {
    const ret = await next(req);
    return {
        data: ret.response,
        error: httpRequest_1.isError(ret.status)
    };
}
exports.statusErrorMiddleware = statusErrorMiddleware;
//# sourceMappingURL=statusErrorMiddleware.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/http/statusErrorMiddleware.js
// module id = 2271
// module chunks = 0